module.exports = __webpack_public_path__ + "media/images/40yrs-bottom-69742df455864b86481e203917f77de0.jpg";